import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAspectRatio169: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="aspect-ratio-16-9, landscape" maskId="round-filled-radius-0-stroke-1.5-IconAspectRatio169"><path d="M1.75 5C1.33579 5 1 5.33579 1 5.75V18.25C1 18.6642 1.33579 19 1.75 19H22.25C22.6642 19 23 18.6642 23 18.25V5.75C23 5.33579 22.6642 5 22.25 5H1.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAspectRatio169;
